// extracted by mini-css-extract-plugin
module.exports = {"plan__team":"TeamPage_plan__team__3uNof"};